import { render, staticRenderFns } from "./TheTransactionsTable.vue?vue&type=template&id=d633e794"
import script from "./TheTransactionsTable.vue?vue&type=script&lang=js"
export * from "./TheTransactionsTable.vue?vue&type=script&lang=js"
import style0 from "./TheTransactionsTable.vue?vue&type=style&index=0&id=d633e794&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports